import React from 'react';

import {useI18n} from '@udemy/i18n';
import {AlertBanner} from '@udemy/react-messaging-components';

export const NoPlanAlertBanner = () => {
    const {gettext} = useI18n();
    return (
        <AlertBanner
            showCta={false}
            title={gettext(
                "We're working to make Personal Plan available for more learners. Stay tuned.",
            )}
        />
    );
};
